import React, { useEffect } from 'react'
import FAQ from './FAQ'
import {Link} from "react-router-dom";
import {Button} from 'antd';

export default function Review(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Back-cover review";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_1735767839_600.jpg'}
                    srcSet={`/images/shutterstock_1735767839_1200.jpg 4000w`}
                    alt="Back-cover review"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1>Write a Back-cover review</h1>
                    </header>
                    <p>Are you a self-published author or simply just need a little help promoting your book? Fear not, for only &#163;9.99 I can write you a succinct back-cover review. The review would be a complementary phrase or a maximum of a two-line acclamatory sentence.</p>
                    <Link to="/request?service=review"><Button type="primary">Request to write back-cover review</Button></Link>
                </div>
            </div>
            <div className="content-wrapper">
                <FAQ topic='review' />
                <FAQ topic='general' />
            </div>

        </div>
    )
}
